import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Text } from 'v3/components';
import * as S from '../styles';

export default function ConcludeAdjustment({
  item,       
  elapsedText,   
  value,   
  onChange, 
  loading, 
  errors = {},     
  submitError = '', 
  maxLength = 2000,
}) {
  const descErr = errors.description;

  return (
    <div
      style={{
        ...S.formWrap,
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        padding: 16,
      }}
    >
      <Row className="align-items-center mb-3">
        <Col>
          <Text type="header" color="dark">Conclusão de pendência:</Text>
        </Col>
        <Col className="text-right">
          <Text type="label" color="dark" weight={600}>
            {item?.id} - {item?.reason}
          </Text>
        </Col>
      </Row>

      <div className="mb-3">
        <Text type="body" color="dark">Tempo decorrido: {elapsedText || '-'}</Text>
      </div>

      {submitError ? (
        <div className="alert alert-danger py-2 px-3 mb-3">
          {submitError}
        </div>
      ) : null}

      <Form.Group className="mb-2" controlId="concludeResolution">
        <Form.Label className="d-flex justify-content-between align-items-center">
          <span>
            <Text type="label" color="dark" weight={600}>
              Resolução <span style={{ color: '#dc2626' }}>*</span>
            </Text>
          </span>
          <small className="text-muted">
            {`${(value || '').length}/${maxLength}`}
          </small>
        </Form.Label>

        <Form.Control
          as="textarea"
          rows={6}
          value={value}
          onChange={(e) => {
            const v = e.target.value?.slice(0, maxLength);
            onChange(v);
          }}
          placeholder="Descreva a resolução…"
          style={{ resize: 'vertical', borderColor: '#e5e7eb', background: '#ffffff' }}
          isInvalid={!!descErr}
          disabled={!!loading}
        />
        <Form.Control.Feedback type="invalid">
          {descErr}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}
